<template>
  <div class="outer-wrapper">

    <div
      class="border rounded text-white item-holder"
      :class="itemClasses"
    >
      <b-form-checkbox
        v-model="isSelected"
        :disabled="statusVariant === 'success'"
      />
      <span
        class="group-number cursor-pointer"
        @click="displayDetails = true"
      >
        #{{ rgStockReport.rack_group_no }}
      </span>

      <span style="margin-right: 10px; width: 25px;">
        {{ rgStockReport.items_count }}
      </span>

      <a
        v-if="rgStockReport.report_file"
        :href="rgStockReport.report_file"
        target="_blank"
        style="margin-right: 10px;"
      >
        <span>RF</span>
      </a>
      <a
        v-if="rgStockReport.verified_file"
        :href="rgStockReport.verified_file"
        target="_blank"
      >
        <span>VF</span>
      </a>
    </div>

    <RackGroupStockReportDetailsModal
      v-if="displayDetails"
      :id="rgStockReport.id"
      @modal-closed="displayDetails = false"
    />

  </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'
import RackGroupStockReportDetailsModal from './RackGroupStockReportDetailsModal.vue'

export default {
  components: {
    BFormCheckbox,
    RackGroupStockReportDetailsModal,
  },
  props: {
    rgStockReport: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      displayDetails: false,
    }
  },
  computed: {
    statusVariant() {
      switch (this.rgStockReport.status) {
        case 'Completed':
          return 'success'

        case 'Initiated':
          return 'warning'

        case 'Created':
        default:
          return 'secondary'
      }
    },
    itemClasses() {
      const classes = `bg-${this.statusVariant} border-${this.statusVariant}`
      return classes
    },
    isSelected: {
      get() {
        return this.$store.getters['stocks/selectedRGStockReports'].includes(this.rgStockReport.id)
      },
      set(newVal) {
        if (newVal) {
          this.$store.dispatch('stocks/selectRGStockReports', { ids: [this.rgStockReport.id] })
        } else {
          this.$store.dispatch('stocks/unselectRGStockReports', { ids: [this.rgStockReport.id] })
        }
      },
    },
  },
}
</script>

<style scoped>

.outer-wrapper{
  display: flex;
  align-items: center;
  width:160px;
}

.item-holder{
  display: flex;
  width: 150px;
  align-items: center;
  padding: 2px 5px;
}

.file-icon {
  color: white;
}

.item-holder a{
  color: white;
}

.group-number {
  margin-right: 10px;
}
</style>
